import { render, staticRenderFns } from "./purchaseData.vue?vue&type=template&id=cbe31e6c&scoped=true&"
import script from "./purchaseData.vue?vue&type=script&lang=js&"
export * from "./purchaseData.vue?vue&type=script&lang=js&"
import style0 from "./purchaseData.vue?vue&type=style&index=0&id=cbe31e6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe31e6c",
  null
  
)

export default component.exports